module.exports = __webpack_public_path__ + "static/media/Nigel Morris.1510c8bf.png";